import { createAction, createReducer } from 'redux-act';
import { useSelector } from 'react-redux';
import { BureauData, CategoryFilter, OfferItems } from '../../components/offers.new/types';
import type { UserPredictions } from '../../services/offers/offers.types';
import { CREDIT_SECURITY_VALUES } from '../../constants/sources';
import { ArrangeItem } from '../../helpers/client/arrange';

interface IState {
    initialized: boolean;
    calcId: string;
    bureauData: BureauData;
    userPredictions: UserPredictions;
    items: OfferItems;
    filters: {
        categoryFilters: Array<CategoryFilter>;
        creditSecurityFilterValue: ValuesOf<typeof CREDIT_SECURITY_VALUES>;
    };
    /** CF-1222 */
    isTinkoffBannerCanceledManually: boolean;
    /** CF-1560 */
    arrange: Record<string, ArrangeItem>;
}

const defaultState: IState = {
    initialized: false,
    calcId: '',
    bureauData: {},
    userPredictions: [],
    items: {
        suitable: [],
        recommended: [],
        final: [],
        unsuitable: [],
        decisionOffers: [],
    },
    filters: {
        categoryFilters: [],
        creditSecurityFilterValue: CREDIT_SECURITY_VALUES.DOES_NOT_MATTER,
    },
    isTinkoffBannerCanceledManually: false,
    arrange: {},
};

/** @deprecated not used */
export const setBureau = createAction<BureauData>('set bureau');

export const setOffersData = createAction<Partial<IState>>('set offers data');

export const setFilters = createAction<Partial<IState['filters']>>('set filters');

export const setDecisionOffers = createAction<IState['items']['decisionOffers']>('set decisionOffers');

/** Данные, связанные с компонентом выдачи кредита */
export const offerReducer = createReducer({}, defaultState)
    .on(setBureau, (state, payload) => {
        return {
            ...state,
            bureauData: payload,
        };
    })
    .on(setFilters, (state, payload) => {
        return {
            ...state,
            filters: {
                ...state.filters,
                ...payload,
            },
        };
    })
    .on(setDecisionOffers, (state, payload) => {
        return {
            ...state,
            items: {
                ...state.items,
                decisionOffers: payload,
            },
        };
    })
    .on(setOffersData, (state, payload) => {
        return {
            ...state,
            ...payload,
        };
    });

export const useOffers = () => useSelector((state: { offers: IState }) => state.offers);

export const useDecisionOffers = () => useSelector((state: { offers: IState }) => state.offers.items.decisionOffers);
